import { IApiResponse, IPaginatedResponse } from 'types'
import {
  EXAM_DETAIL,
  EXAM_LIST_ECG,
  EXAM_LIST_CXRAY,
  EXAM_PATCH,
  EXAM_UPDATE_DIAGNOSIS_STATUS,
  EXAM_FEEDBACK,
  MEDICAL_REVIEWS_LOG,
  EXAM_REPORT,
  EXAM_REPORT_LIST,
  CXRAY_EXAM_UPLOAD,
  ECG_EXAM_UPLOAD
} from './CONSTANTS'
import { request } from 'services/base'
import {
  ICxrayExamUploadRequest,
  IEcgExamUploadRequest,
  IExamPatchPayload,
  IExamReportResponse,
  IExamResponse,
  IFeedbackPayload,
  IMedicalReviewPayload
} from 'types/exam/types'

export interface IExamListParams {
  hospital_id: string
  patient_id?: string
  result_type?: string
  /** Somente Raio-X; ignorado pelo endpoint de ECG */
  subtype?: string
  created_at_start?: string
  created_at_end?: string
  acquisition_date_start?: string
  acquisition_date_end?: string
  diagnosis_created_at_start?: string
  diagnosis_created_at_end?: string
  diagnosis_status?: '0' | '1' | '2'
  /** Somente Raio-X; níveis de Revisão (CSV, ex.: "0,2"). Ignorado pelo ECG */
  review?: string
  /** Somente Raio-X; níveis de Prioridade (CSV, ex.: "1,3"). Ignorado pelo ECG */
  priority?: string
  order_by: string
  order_direction?: 'asc' | 'desc'
  limit?: number
  offset?: number
  is_admin?: boolean
}

/** Lista exames de ECG (endpoint dedicado, sem filtro de tipo) */
export const getEcgExamList = async (
  params: IExamListParams
): Promise<IApiResponse<IPaginatedResponse<IExamResponse>>> =>
  await request({
    url: EXAM_LIST_ECG,
    method: 'get',
    params
  })

/** Lista exames de Raio-X (endpoint dedicado, aceita `subtype`) */
export const getCxrayExamList = async (
  params: IExamListParams
): Promise<IApiResponse<IPaginatedResponse<IExamResponse>>> =>
  await request({
    url: EXAM_LIST_CXRAY,
    method: 'get',
    params
  })

export const getExamDetail = async (
  examId: string
): Promise<IApiResponse<IExamResponse>> =>
  await request({
    url: EXAM_DETAIL(examId),
    method: 'get'
  })

export const patchExam = async (
  examId: string,
  data: IExamPatchPayload
): Promise<IApiResponse<any>> =>
  await request({
    url: EXAM_PATCH(examId),
    method: 'patch',
    data
  })

export const uploadCxrayExam = async (
  params: ICxrayExamUploadRequest
): Promise<IApiResponse<any>> => {
  return await request({
    url: CXRAY_EXAM_UPLOAD,
    method: 'post',
    data: params
  })
}
export const updateDiagnosisStatus = async (
  diagnosisId: string,
  status: number
): Promise<IApiResponse<any>> =>
  await request({
    url: EXAM_UPDATE_DIAGNOSIS_STATUS(diagnosisId),
    method: 'put',
    data: { status }
  })

export const createFeedback = async (
  feedbackData: IFeedbackPayload
): Promise<IApiResponse<any>> =>
  await request({
    url: EXAM_FEEDBACK,
    method: 'post',
    data: feedbackData
  })

export const updateMedicalReview = async (
  feedbackData: IMedicalReviewPayload
): Promise<IApiResponse<any>> =>
  await request({
    url: MEDICAL_REVIEWS_LOG,
    method: 'post',
    data: feedbackData
  })

export const uploadReviewPDF = async (
  file: Blob,
  filename: string,
  idExamDiagnosis: string,
  idProfessional: string
): Promise<IApiResponse<any>> => {
  const formData = new FormData()
  formData.append('pdf_file', file, filename)
  formData.append('id_exam_diagnosis', idExamDiagnosis)
  formData.append('id_professional', idProfessional)

  return await request({
    url: EXAM_REPORT,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const uploadEcgExam = async (
  params: IEcgExamUploadRequest
): Promise<IApiResponse<any>> => {
  return await request({
    url: ECG_EXAM_UPLOAD,
    method: 'post',
    data: params
  })
}

export const getExamReports = async (
  examDiagnosesId: string
): Promise<IApiResponse<IExamReportResponse[]>> =>
  await request({
    url: EXAM_REPORT_LIST(examDiagnosesId),
    method: 'get'
  })
